import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.21 20.201l.297-.282a2.166 2.166 0 011.493-.59v0c.56 0 1.097.213 1.493.59l.297.282a2.923 2.923 0 002.014.795h.344c1.574 0 2.85-1.215 2.85-2.713v0c0-.907-.477-1.754-1.27-2.258v0a6.79 6.79 0 01-2.17-2.203l-.805-1.326c-.562-.926-1.6-1.496-2.722-1.496v0c-1.104 0-2.128.552-2.696 1.454l-.9 1.43a6.798 6.798 0 01-2.114 2.11l-.05.032c-.792.503-1.268 1.35-1.268 2.257v0c0 1.498 1.275 2.713 2.849 2.713h.344c.756 0 1.48-.286 2.014-.795v0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.501 4.004c-.828 0-1.499.651-1.499 1.454v1.09c0 .803.671 1.454 1.5 1.454.827 0 1.499-.65 1.499-1.454v-1.09c0-.803-.672-1.454-1.5-1.454zM4.503 9.002c-.828 0-1.5.651-1.5 1.454v1.09c0 .803.672 1.454 1.5 1.454s1.5-.65 1.5-1.454v-1.09c0-.803-.672-1.454-1.5-1.454zM15.498 4.004c-.828 0-1.499.651-1.499 1.454v1.09c0 .803.671 1.454 1.5 1.454.827 0 1.499-.65 1.499-1.454v-1.09c0-.803-.672-1.454-1.5-1.454zM19.497 9.002c-.828 0-1.5.651-1.5 1.454v1.09c0 .803.672 1.454 1.5 1.454s1.5-.65 1.5-1.454v-1.09c0-.803-.672-1.454-1.5-1.454z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgPets as ReactComponent };
